import { ILogger, LogLevel } from '@microsoft/signalr';
import { isTransientHubDisconnect } from './elmahIo';

/**
 * SignalR client logger that keeps unexpected hub failures as console.error
 * (elmah.io captures those) but demotes transport drops to warn.
 *
 * HubConnectionBuilder.configureLogging(LogLevel.Error) writes every disconnect
 * — including laptop sleep and 1006 — to console.error, which flooded elmah
 * after captureConsoleMinimumLevel was enabled.
 */
export const signalRConsoleLogger: ILogger = {
  log(logLevel: LogLevel, message: string): void {
    if (logLevel < LogLevel.Error) {
      return;
    }
    if (isTransientHubDisconnect(message)) {
      console.warn(message);
      return;
    }
    console.error(message);
  },
};
